import { Create, SelectInput, SimpleForm, required } from 'react-admin';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';
import ImageInput from '../../../../commonComponents/UploadInputs/ImageInput';
import { uploadTypes } from '../../../../config/constants';

const difficultyChoices = [
  { id: 'easy', name: 'Easy' },
  { id: 'hard', name: 'Hard' },
];

const JigsawEventsCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <CustomDateInput label="Date" source="date" validate={required()} />
      <SelectInput source="difficulty" label="Difficulty" choices={difficultyChoices} validate={required()} />
      <ImageInput
        uploadType={uploadTypes.jigsaw}
        imageInputSource="image_file_key"
        label="Puzzle image"
        validate={required()}
        helperText="Javasolt képarány: 3:4"
      />
    </SimpleForm>
  </Create>
);

export default JigsawEventsCreate;
